<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="form" :inline="true" status-icon label-width="130px" class="query-form" size="mini">
            <el-form-item label="站点：" class="query-form-item">
                <el-select
                    v-model="formData.country_code"
                    ref="carrerSelect"
                    style="width: 120px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us" style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键词：" class="query-form-item">
                <el-input
                    type="textarea"
                    :rows="10"
                    placeholder="输入关键词，用换行区分每个关键词（必填）"
                    style="width: 220px"
                    v-model="textarea">
                </el-input>
            </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
        <el-button
            style="float:right;margin-left:6px;"
            size="mini"
            plain
            @click="handleClose(true)"
        >取 消</el-button>
        <el-button style="float:right" size="mini" type="primary" @click="accountForm()" :loading="disabled">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
import { str_arr } from "@/utils/method";
export default {
    data() {
        return {
            disabled: false,
            formData: {},
            textarea: ""
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        us_arr: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        //时间筛选
        datechange(tab) {
            if (tab) {
                this.formData.begin_date = tab[0];
                this.formData.end_date = tab[1];
            } else {
                this.formData.begin_date = "";
                this.formData.end_date = "";
            }
        },
        accountForm() {
            if (!this.formData.country_code) {
                this.$message({
                    type: "error",
                    message: "请选择站点！"
                });
                return;
            }
            this.formData.keyword = str_arr(this.textarea);
            if (this.formData.keyword.lenght == 0) {
                this.$message({
                    type: "error",
                    message: "请填写最少一个关键词！"
                });
                return;
            }
            this.disabled = true;
            this.$notify.info({
                title: "提示",
                message: "导出数据越多需要的时长也就越久，大约需要1~2分钟",
                duration: 30000
            });
            api.export_search_data(this.formData)
                .then(res => {
                    this.disabled = false;
                    if (res.code === 0) {
                        window.open(
                            process.env.VUE_APP_API_BASE + "/" + res.data
                        );
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabled = false;
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.formData = {};
            this.textarea = "";
            this.$emit("close-callback", isshow);
            this.disabled = false;
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
}
</style>
